import { mapState } from 'vuex'
import {
  notifyExternalServices,
  ACTIONS,
} from '@/services/external-communication/external-communication'
import EmailSubscriptionService from '@/api/services/_shared/email-subscription-service'

export const SOURCES = {
  popup: 'Website Newsletter Overlay',
  footer: 'Website Newsletter Footer',
}

const REQUEST_STATES = {
  initial: 0,
  submitting: 1,
  error: 2,
  success: 3,
}

export default {
  data() {
    return {
      email: '',
      hideErrorMessage: false,
      errorMessage: null,
      requestState: REQUEST_STATES.initial,
      REQUEST_STATES,
      submitAttempt: 0,
      genderOptions: [
        { text: 'Shopping for', value: '' },
        { text: this.$t('newsletter.subscribe_mens'), value: 'male' },
        { text: this.$t('newsletter.subscribe_womens'), value: 'female' },
        { text: this.$t('newsletter.subscribe_all'), value: 'Other' },
      ],
      onSuccess: () => {},
      onError: () => {},
    }
  },

  computed: {
    ...mapState('page', ['hostname', 'locale']),
  },

  methods: {
    setInvalidEmailErrorMessage() {
      const setMsg = () => {
        this.errorMessage = this.$t('errors.invalid_email')
      }
      // to make it flash every time the submit button is clicked
      if (this.errorMessage) {
        this.hideErrorMessage = true
        clearTimeout(this.invalidEmailErrorMessageTimeout)
        this.invalidEmailErrorMessageTimeout = setTimeout(() => {
          this.hideErrorMessage = false
          setMsg()
        }, 100)
      } else {
        setMsg()
      }
    },

    notifyGtm(source) {
      const action = source === SOURCES.footer ? 'footer' : 'newsletter_overlay'
      notifyExternalServices({
        action: ACTIONS.subscriptions,
        details: { action, label: 'subscribed' },
      })
    },

    submitNewsletterSignupForm(formData) {
      const state = this.requestState
      this.submitAttempt++

      if (state == REQUEST_STATES.submitting || state == REQUEST_STATES.success) return
      if (!On.helpers.validateEmail(this.email)) return this.setInvalidEmailErrorMessage()

      this.errorMessage = null
      this.requestState = REQUEST_STATES.submitting

      formData.source === SOURCES.footer
        ? this.subscribeToNewsletterWithCors(formData)
        : this.subscribeToNewsletter(formData)
    },

    async subscribeToNewsletter({ gender, source, listId }) {
      const variables = {
        attributes: {
          email: this.email,
          listId,
          isSubscribingToNewsletter: true,
          gender,
          subscriptionType: source,
        },
      }
      if (await EmailSubscriptionService.registerToMailingList(variables)) {
        this.onSuccessfulSubscription(source)
      } else {
        this.onUnsuccessfulSubscription()
      }
    },

    subscribeToNewsletterWithCors({ gender, source }) {
      const variables = { email: this.email, gender, source }
      this.$http
        .post(`${this.hostname}/${this.locale}/newsletter/subscribe`, variables)
        .then(() => this.onSuccessfulSubscription(source))
        .catch(() => this.onUnsuccessfulSubscription())
    },

    onSuccessfulSubscription(source) {
      this.requestState = REQUEST_STATES.success
      On.DynamicYield.trackNewsletterSubscription(this.email)
      this.notifyGtm(source)
      this.onSuccess()
    },

    onUnsuccessfulSubscription() {
      this.requestState = REQUEST_STATES.error
      setTimeout(() => (this.requestState = REQUEST_STATES.initial), 3000)
      this.onError()
    },
  },
}
